import { showDeleteConfirmation } from '@modules/common';
import { map, switchMap } from 'rxjs/operators';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { handleMessage, requestMessage } from '@business/messages';
import { BrandAPI } from '@business/api/brand';
import { BrandResponse, BrandId } from '@business/entities/brand';
import { CompanyId } from '@business/entities/companies';
import { OvertimeAPI } from '@business/api/overtime';
import { OvertimeFormData } from '@modules/dashboard/DashboardPage/ClockinToolbar/AddEditOvertimeModal/AddEditOvertimeModal';
import { OvertimeId, OvertimeResponse } from '@business/entities/overtime';
import { UserId } from '@business/entities/account';
import { OvertimeReportFormData } from '@modules/dashboard/DashboardPage/ClockinToolbar/OvertimeReportModal/OvertimeReportModal';

export class OvertimeBloc extends BaseBloc {
  private readonly overtimeRepo = new Repository<OvertimeResponse>({
    getItemId: overtime => overtime.id,
  });

  readonly brands$ = this.overtimeRepo.items$;
  readonly selectBrand = this.overtimeRepo.selectItem;

  onReset() {
    this.overtimeRepo.reset();
  }

  fetchUserOvertimes = (id: UserId) => {
    return OvertimeAPI.fetchUserOvertimes(id).pipe(handleMessage({ error: requestMessage('fetch_brands_error') }));
  };

  // fetchBrand = (id: BrandId) => {
  //   return BrandAPI.fetchBrand(id).pipe(
  //     this.overtimeRepo.ops.upsertOne(item => ({ item })),
  //     handleMessage({ error: requestMessage('fetch_brands_error') }),
  //   );
  // };

  createOvertime = (data: OvertimeFormData) => {
    return OvertimeAPI.createOvertime(data).pipe(
      // this.overtimeRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_brand'),
      }),
    );
  };

  updateOvertime = (id: OvertimeId, data: OvertimeFormData) => {
    return OvertimeAPI.updateOvertime(id, data).pipe(
      // this.overtimeRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_brand'),
      }),
    );
  };

  deleteOvertime = (id: OvertimeId) => {
    return showDeleteConfirmation('Delete Overtime', `Do you really want to delete this overtime?`).pipe(
      switchMap(() => OvertimeAPI.deleteOvertime(id)),
      handleMessage({
        type: requestMessage('delete_brand'),
      }),
    );
  };

  export = (data: OvertimeReportFormData) => {
    return OvertimeAPI.exportReport(data).pipe(handleMessage({ error: requestMessage('fetch_clockin_report_error') }));
  };
}
